// deploy-pipelines-run-overrides (Wave 4, AC-11/AC-12/AC-13) — shapes a `PipelineBranchListDto`
// (`POST /api/pipelines/{id}/branches`) into picker options for the run dialog, marking the
// branch a no-override run would build right now (`EffectiveBranch`) so the picker can flag the
// default rather than leaving every row looking equally arbitrary. Pure, no React, no network —
// the picker component only renders what this returns.
//
// AC-13 surfacing: `PageLimit` is non-null ONLY when the BE's page-following cap is what stopped the
// listing (GitHub only — Azure DevOps returns every ref in one page), and it is expressed in BRANCHES.
// So a non-null value means the list genuinely may not be exhaustive and the FE must say so. A repo
// that fitted inside the cap sends null and gets no warning — previously the BE sent the raw page
// count unconditionally, so every GitHub listing, even a 3-branch one, claimed "there may be more".
export const buildBranchPickerOptions = (branchListResult) => {
	const branches = branchListResult?.Branches ?? [];
	const effectiveBranch = branchListResult?.EffectiveBranch ?? null;

	const options = branches.map((name) => ({
		value: name,
		label: name === effectiveBranch ? `${name} (current default)` : name,
		isEffective: name === effectiveBranch
	}));

	const pageLimit = branchListResult?.PageLimit;
	const boundedNote =
		typeof pageLimit === 'number'
			? `Showing up to ${pageLimit} branches — there may be more in the repository.`
			: null;

	return { options, boundedNote };
};

export default buildBranchPickerOptions;
